import { debounce } from 'lodash';
import validateField from '@/entities/validator';
import EventEmitter from '@/helpers/eventEmitter';
import i18n from '@/i18n';

export default class Form {
    /**
     * Create Form
     * @param {Object} options
     * @param {Object} options.items
     * @param {Promise} options.action - экшен, вызывается при отправке формы
     * @param {Function} options.validateHandler - срабатывает при отправление формы, если в полях есть ошибка
     * @param {Function} options.failedHandler - срабатывает при отправление формы, если в ответе есть ошибки
     * @param {Function} options.successHandler - срабатывает при успешной отправке формы
     * @param {Function} options.collectData - переопределяет функцию сбора данный формы
     * @param {Function} options.validate- переопределяет функцию валидации формы
     */
    constructor(options) {
        this.items = options.items;
        this.fieldKeys = this.createFieldKeys();
        this.initFields();
        this.errors = [];
        this.action = options.action;
        this.validateHandler = options.validateHandler;
        this.successHandler = options.successHandler;
        this.failedHandler = options.failedHandler;
        if (options.collectData) this.collectData = options.collectData(this);
        if (options.validate) this.validate = options.validate(this);
    }

    /**  получаем массив ключей полей (item с type === 'field') */
    createFieldKeys() {
        const itemKeys = Object.keys(this.items);
        const fieldKeys = [];
        itemKeys.forEach((key) => {
            if (this.items[key].type === 'field') fieldKeys.push(key);
            if (this.items[key].type === 'form') fieldKeys.push(key);
            if (this.items[key].type === 'arrayForm') fieldKeys.push(key);
        });
        return fieldKeys;
    }

    /** добавляем свойство value, если оно отсутствует */
    initFields() {
        this.fieldKeys.forEach((key) => {
            const item = this.items[key];
            const type = item.type;
            if (item.value === undefined) item.value = null;
            if (type === 'field' && item.props.rules === undefined) item.props.rules = [];
            if (type === 'field' && item.props.errors === undefined) item.props.errors = [];
        });
    }

    validate() {
        this.errors = []; // костыль
        const data = this.fieldKeys.map((key) => this.items[key]);
        return data.reduce((previous, current) => {
            const type = current.type;
            if (type === 'field') {
                if (current.props.validateFunction) {
                    current.props.errors = current.props.validateFunction(current, this);
                } else {
                    current.props.errors = validateField(current.value, current.props.rules);
                }
                if (current.props.errors.length > 0) previous = false;
            }
            if (type === 'form') {
                if (!current.value.validate()) previous = false;
            }
            if (type === 'arrayForm') {
                current.value.forEach((subform) => {
                    if (!subform.validate()) previous = false;
                });
            }
            return previous;
        }, true);
    }

    // фронтовые ошибки
    validateField(fieldKey, groupKey, index) {
        let item;
        if (groupKey === null) item = this.items[fieldKey];
        if (groupKey && index === null) item = this.items[groupKey].value.items[fieldKey];
        if (index !== null) item = this.items[groupKey].value[index].items[fieldKey];

        const type = item.type;
        if (type === 'field') {
            if (item.props.validateFunction) item.props.errors = item.props.validateFunction(item, this);
            else item.props.errors = validateField(item.value, item.props.rules);
        }
        if (type === 'form') item.value.validate();
        if (type === 'arrayForm') console.log('validateField', fieldKey);
    }

    validateFieldDebounced = debounce((fieldKey, groupKey, index) => {
        this.validateField(fieldKey, groupKey, index);
    }, 500);

    // прокидываем ошибки от бэка
    updateErrorsFromAPI(errors) {
        if (!errors) return;
        this.fieldKeys.forEach((key) => {
            const item = this.items[key];
            const type = item.type;
            const error = errors.find((error) => error.key === key);

            //TODO: когда появится перевод - передавать error.type для перевода
            if (type === 'field') {
                if (error) {
                    const hint = error.hint;
                    item.props.errors = hint ? [`${error.message}. ${hint}`] : [error.message];
                } else item.props.errors = [];
            }
            if (type === 'form') item.value.updateErrorsFromAPI(error);
            if (type === 'arrayForm')
                item.value.forEach((subform, index) => {
                    subform.updateErrorsFromAPI(error.errors[index]);
                });
        });
    }

    collectData() {
        return this.fieldKeys.reduce((previous, current) => {
            if (this.items[current].type === 'field') previous[current] = this.items[current].value;
            if (this.items[current].type === 'form') previous[current] = this.items[current].value.collectData();
            if (this.items[current].type === 'arrayForm')
                previous[current] = this.items[current].value.map((subform) => subform.collectData());
            return previous;
        }, {});
    }

    async submit() {
        try {
            const isValid = this.validate();
            this.validateHandler(isValid);
            if (!isValid) {
                EventEmitter.trigger('show-noty', {
                    type: 'error',
                    text: i18n.global.t('notifications.errors.validate'),
                });
            }
            if (!isValid) throw new Error('Validation Failed');
            const data = this.collectData();
            await this.action(data).then((response) => {
                if (Array.isArray(response)) {
                    const [error, result] = response;
                    if (!error) this.successHandler(result);
                    else {
                        error.notify();
                        this.errors = result?.errors;
                        if (this.errors) this.updateErrorsFromAPI(this.errors);
                        this.failedHandler(result);
                    }
                } else {
                    console.log('object', response);
                    if (response.status === 200) this.successHandler(response);
                    else if (response.status === 400) this.failedHandler(response);
                    else this.failedHandler(response);
                }
            });
        } catch (error) {
            console.error(error);
            return error;
        }
    }
}
